import React, { useEffect, useState } from 'react';

interface RewardPopupProps {
  isOpen: boolean;
  reward: number;
  icon?: string;
  onClose: () => void;
}

const RewardPopup: React.FC<RewardPopupProps> = ({ isOpen, reward, icon = '⭐', onClose }) => {
  const [confetti, setConfetti] = useState<Array<{id: number, left: string, color: string, size: string, delay: string}>>([]);
  const [autoCloseTimer, setAutoCloseTimer] = useState<NodeJS.Timeout | null>(null);
  
  // Создаем эффект конфетти при открытии попапа
  useEffect(() => {
    if (isOpen) {
      // Создаем конфетти
      const newConfetti = [];
      const colors = ['#ff0000', '#00ff00', '#0000ff', '#ffff00', '#ff00ff', '#00ffff'];
      
      // Создаем 40 конфетти с разными параметрами
      for (let i = 0; i < 40; i++) {
        newConfetti.push({
          id: i,
          left: `${Math.random() * 100}%`,
          color: colors[Math.floor(Math.random() * colors.length)],
          size: `${Math.random() * 8 + 5}px`,
          delay: `${Math.random() * 1.5}s`
        });
      }
      setConfetti(newConfetti);
      
      // Автоматически закрываем попап через 5 секунд
      const timer = setTimeout(() => {
        onClose();
      }, 5000);
      
      setAutoCloseTimer(timer);
      
      return () => {
        if (autoCloseTimer) {
          clearTimeout(autoCloseTimer);
        }
      };
    }
  }, [isOpen, onClose]);
  
  // Функция для отмены автозакрытия при клике на кнопку
  const handleButtonClick = () => {
    if (autoCloseTimer) {
      clearTimeout(autoCloseTimer);
    }
    onClose();
  };
  
  if (!isOpen) return null;
  
  return (
    <div className="reward-popup">
      <div className="reward-popup-content">
        <div className="reward-popup-title">Задание выполнено!</div>
        <div className="reward-popup-amount">
          +{reward} <span className="reward-star-big">{icon}</span>
        </div>
        <div className="reward-popup-message">
          Награда успешно начислена
        </div>
        <button className="reward-popup-button" onClick={handleButtonClick}>
          Отлично!
        </button>
      </div>
      
      {/* Анимированное конфетти */}
      <div className="confetti-container">
        {confetti.map((item) => (
          <div 
            key={item.id}
            className="confetti confetti-animation"
            style={{
              left: item.left,
              backgroundColor: item.color,
              width: item.size,
              height: item.size,
              animationDelay: item.delay
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default RewardPopup; 